module.exports = __webpack_public_path__ + "img/Blair.14052161.jpg";